import { Card, CardHeader, CardContent } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { formatDateTime } from '@/utils/formatters';
import { Building2, Calendar, Globe, Mail, Phone, MapPin } from 'lucide-react';

interface OrgInfoCardProps {
  org: any;
}

export function OrgInfoCard({ org }: OrgInfoCardProps) {
  const memberCount = org.members?.length ?? org.memberCount ?? 0;
  const domainCount = org.domains?.length ?? org.domainCount ?? 0;
  const isActive = !org.deletedAt;

  return (
    <Card>
      <CardHeader title="Informations" />
      <CardContent>
        <div className="space-y-4">
          <div className="flex items-center gap-3">
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary-500/20">
              <Building2 className="h-6 w-6 text-primary-400" />
            </div>
            <div>
              <p className="font-semibold text-neutral-900 dark:text-neutral-100">{org.name}</p>
              <Badge variant={isActive ? 'success' : 'danger'}>{isActive ? 'active' : 'suspendu'}</Badge>
            </div>
          </div>
          <div className="space-y-3 text-sm">
            {org.slug && (
              <p className="text-xs text-neutral-500">slug: {org.slug}</p>
            )}
            <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
              <Globe className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
              <span>{domainCount} domaine(s), {memberCount} membre(s)</span>
            </div>
            {org.siret && (
              <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
                <Building2 className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
                <span>SIRET: {org.siret}</span>
              </div>
            )}
            {org.email && (
              <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
                <Mail className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
                <span>{org.email}</span>
              </div>
            )}
            {org.phone && (
              <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
                <Phone className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
                <span>{org.phone}</span>
              </div>
            )}
            {(org.address || org.city) && (
              <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
                <MapPin className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
                <span>{[org.address, org.postalCode, org.city].filter(Boolean).join(', ')}</span>
              </div>
            )}
            <div className="flex items-center gap-2 text-neutral-600 dark:text-neutral-400">
              <Calendar className="h-4 w-4 text-neutral-400 dark:text-neutral-600" />
              <span>Créé le {formatDateTime(org.createdAt)}</span>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
